module.exports = __webpack_public_path__ + "img/multi-func.3d8abe52.png";